import { yupResolver } from '@hookform/resolvers/yup';
import { TextField } from '@material-ui/core';
import React, { useMemo } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { sanitizeAlphaNumeric, sanitizeNumber } from 'utils/formatter';
import { buyersCreateStep1Schema } from './Step1.yup';
import { BuyersCreateForm, BuyersCreateStepProps, useBuyerCreateStepsHooks } from './StepsShared';

export const Step1: React.FC<BuyersCreateStepProps> = ({ onSubmit, formName, previousStepData }) => {
  const { t, classes } = useBuyerCreateStepsHooks();

  const schema = useMemo(() => buyersCreateStep1Schema(t), [t]);

  const { control, handleSubmit, setValue } = useForm<BuyersCreateForm>({
    mode: 'onBlur',
    defaultValues: previousStepData,
    resolver: yupResolver(schema),
  });
  return (
    <>
      <form className={classes.form} id={formName} onSubmit={handleSubmit(onSubmit)}>
        <div className={classes.fieldLine}>
          <Controller
            name="name"
            control={control}
            render={({ field: { ref, onChange, ...inputProps }, fieldState }) => (
              <TextField
                fullWidth
                id="name"
                variant="outlined"
                label={t('buyers.create.step1.name')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                inputRef={ref}
                InputLabelProps={{ required: true }}
                onChange={e => {
                  setValue('name', sanitizeAlphaNumeric(e.target.value));
                }}
                {...inputProps}
              />
            )}
          />
        </div>
        <div className={classes.fieldLine}>
          <Controller
            name="addressLine"
            control={control}
            render={({ field: { ref, onChange, ...inputProps }, fieldState }) => (
              <TextField
                fullWidth
                id="addressLine"
                variant="outlined"
                label={t('buyers.create.step1.addressLine')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                inputRef={ref}
                onChange={e => {
                  setValue('addressLine', sanitizeAlphaNumeric(e.target.value));
                }}
                {...inputProps}
              />
            )}
          />
        </div>
        <div className={classes.fieldLine}>
          <div className={classes.sharedLine}>
            <Controller
              name="postalCode"
              control={control}
              render={({ field: { ref, onChange, ...inputProps }, fieldState }) => (
                <TextField
                  fullWidth
                  id="postalCode"
                  variant="outlined"
                  label={t('buyers.create.step1.postalCode')}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  inputRef={ref}
                  onChange={e => {
                    setValue('postalCode', sanitizeAlphaNumeric(e.target.value));
                  }}
                  InputLabelProps={{ required: true }}
                  {...inputProps}
                />
              )}
            />
            <Controller
              name="city"
              control={control}
              render={({ field: { ref, onChange, ...inputProps }, fieldState }) => (
                <TextField
                  fullWidth
                  id="city"
                  variant="outlined"
                  label={t('buyers.create.step1.city')}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                  inputRef={ref}
                  onChange={e => {
                    setValue('city', sanitizeAlphaNumeric(e.target.value));
                  }}
                  InputLabelProps={{ required: true }}
                  {...inputProps}
                />
              )}
            />
          </div>
        </div>
        <div className={classes.fieldLine}>
          <Controller
            name="phoneNumber"
            control={control}
            render={({ field: { ref, onChange, ...inputProps }, fieldState }) => (
              <TextField
                fullWidth
                id="phoneNumber"
                variant="outlined"
                label={t('buyers.create.step1.phoneNumber')}
                error={!!fieldState.error}
                helperText={fieldState.error?.message}
                onChange={e => {
                  setValue('phoneNumber', sanitizeNumber(e.target.value));
                }}
                inputRef={ref}
                {...inputProps}
              />
            )}
          />
        </div>
      </form>
    </>
  );
};
